export default [
  // {
  //   name: 'merchant_register_approval',
  //   path: '/merchant/register_approval',
  //   meta: {
  //     loginAuth: process.env.NODE_ENV !== 'development'
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "merchant_register_approval" */ './MerchantRegisterApproval.vue'
  //     )
  // },
  {
    name: 'DPSMerchantRegReport',
    path: '/dps_merchant_reg_rep',
    component: () =>
      import(
        /* webpackChunkName: "DPSMerchantRegReport" */ './DPSMerchantRegReport.vue'
      )
  },
  {
    name: 'DPSMerchantBatchReg',
    path: '/dps_merchant_batch_reg',
    component: () =>
      import(
        /* webpackChunkName: "DPSMerchantBatchReg" */ './DPSBatchRegister/DPSBatchRegister.vue'
      )
  },
  {
    name: 'merchant_manage',
    path: '/merchant_manage',
    component: () =>
      import(/* webpackChunkName: "merchant_manage" */ './index.vue')
  },
  {
    name: 'merchant_detail',
    path: '/merchant_manage/detail',
    component: () =>
      import(/* webpackChunkName: "merchant_manage" */ './detail.vue')
  },
  {
    name: 'merchant_exception',
    path: '/merchant_exception',
    component: () =>
      import(
        /* webpackChunkName: "merchant_exception" */ './Exception/MerchantException.vue'
      )
  },
  {
    name: 'industry_category',
    path: '/industry_category',
    component: () =>
      import(
        /* webpackChunkName: "industry_category" */ './IndustryCategory.vue'
      )
  },
  {
    name: 'ScheduledBankTransferReport',
    path: '/scheduled_bank_transfer_report',
    component: () =>
      import(
        /* webpackChunkName: "scheduled_bank_transfer_report" */ '@/projects/teller/views/BankTransfer/ScheduledBankTransferReport.vue'
      )
  }
]
